export const VERIFICATION_EMAIL_RESEND_CALLBACK = 'VERIFICATION_EMAIL_RESEND_CALLBACK';
export const ACTIVATION_EMAIL_RESEND_CALLBACK = 'ACTIVATION_EMAIL_RESEND_CALLBACK';
export const EVERCALL_DASHBOARD_FORCE_LOGOUT_CALLBACK = 'EVERCALL_DASHBOARD_FORCE_LOGOUT_CALLBACK';
